import propsModalAlerta from '../../interfaces/propsModalAlerta'
import { Button } from '../Styles'
import './modalalerta.css'

function ModalAlerta (props: propsModalAlerta) {

    return (
        <div id='modalAlertaFundo'>
            <section id = 'modalFundoDados'>
                <span>
                    <img src={props.icone} alt='' />
                </span>
                <p>{props.texto}</p>
                <div>
                    <Button type='button' cor={props.cor} isLoading={false} onClick={props.acao}>{props.btnTitulo}</Button>
                </div>
            </section>
        </div>
    )
}

export default ModalAlerta